//import React, { Component } from "react";

import settings from "../../helpers/settings";
import axios from "axios";
import { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "@mui/material/Alert";

import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";

import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useEffect } from "react";

let { KayanURL } = settings;

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function SignIn() {
  const navigate = useNavigate();
  const [role, setRole] = useState("admin");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [companyname, setCompanyname] = useState("");

  const [loginSpinner, setLoginSpinner] = useState(false);
  const [loginError, setLoginError] = useState(null);

  const [usernameValidation, setUsernameValidation] = useState(false);
  const [companynameValidation, setCompanynameValidation] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState(false);
  const isAuthenticated = Cookies.get("id");
  console.log("isAuthenticated", isAuthenticated);

  // useEffect(() => {
  //   if (isAuthenticated) {
  //     navigate("/kayanPortal");
  //   }
  // }, []);
  useEffect(() => {
    if (companyname === "Admin")
      setRole("admin");
    else
      setRole('employee')
  }, [companyname]);

  //define the state
  const handleInputTextChange = (e) => {
    //turn of validations flag

    let name = e.target.name;
    let value = e.target.value;
    if (name === "username") {
      setUsernameValidation(false);
      setUsername(value);
    } else if (name === "password") {
      setPasswordValidation(false);

      setPassword(value);
    }
    else if (name === "companyname") {
      setCompanynameValidation(false);
      setCompanyname(value);
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoginSpinner(false);
    setLoginError(null);
    if (!username || !password || !companyname) {
      if (!password) {
        setPasswordValidation(true);
      }
      if (!username) {
        setUsernameValidation(true);
      }
      if(!companyname){
        setCompanynameValidation(true)
      }
    } else {
      setLoginSpinner(true);

      let loginResult = await axios.put(KayanURL + "/test/users/login/", {
        companyname,
        username,
        password,
      });

      console.log("login result");
      console.log(loginResult);

      if (loginResult) {
        setLoginSpinner(false);
        let { data } = loginResult;
        let { success, error, apiToken } = data;
        if (success) {
          // set cokkies and redirect to check eligibility page
          const expirationTime = new Date(
            new Date().getTime() + 60 * 60 * 1000
          );

          Cookies.set("id", apiToken);
          Cookies.set("user_name", username);
          navigate("/kayanPortal");
          
        } else {
          setLoginError(error);
        }
      }
    }
  };
  const handelAdminLogIn = async (e) => {
    console.log('admin')
    e.preventDefault();
    setLoginSpinner(false);
    setLoginError(null);
    if (!username || !password || !companyname) {
      if (!password) {
        setPasswordValidation(true);
      }
      if (!username) {
        setUsernameValidation(true);
      }
      if(!companyname){
        setCompanynameValidation(true)
      }
    } else {
      setLoginSpinner(true);
      try {
        const result = await axios.put(
          KayanURL + "/test/admin/loginAdmin/",
          {
            username: username.trim(),
            password: password.trim(),
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (result) {
          setLoginSpinner(false);
          const { data } = result;
          if (data) {
            if (data.success) {
              Cookies.set("Admin_Token", data.apiToken);
              navigate('/admin');

            } else {
              const { error } = data;
              if (error) {
                setLoginError(error);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error during admin login:", error);
      }
    
  }
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container
        component="main"
        maxWidth="xs"
        style={{
          border: "1px solid #438e7bcc",
          padding: "40px",
          borderRadius: "20px",
          marginTop: "100px",
          height: "600px",
          boxShadow: "2px solid grey",
          boxShadow:
            "rgba(0, 0, 0, 0.3) 6px 8px 13px 8px, rgba(0, 0, 0, 0.15) 0px 4px 5px 0px, rgba(0, 0, 0, 0.11) 0px 1px 10px 0px",
        }}
      >
        <CssBaseline />
        <Box
          sx={{
            marginTop: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1 }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography
            component="h1"
            variant="h5"
            style={{ color: "white", marginBottom: "20px" }}
          >
            Sign in
          </Typography>
          <Box
            component="form"
            onSubmit={role === "admin" ?handelAdminLogIn:handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              error={companynameValidation ? true : false}
              helperText={companynameValidation ? "Companyname is Required" : ""}
              margin="normal"
              required
              fullWidth
              id="companyname"
              label="Companyname"
              name="companyname"
              value={companyname}
              style={{ backgroundColor: "white", borderRadius: "5px" }}
              autoFocus
              onChange={handleInputTextChange}
            />
            <TextField
              error={usernameValidation ? true : false}
              helperText={usernameValidation ? "Username is Required" : ""}
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              value={username}
              style={{ backgroundColor: "white", borderRadius: "5px" }}
              onChange={handleInputTextChange}
            />
            <TextField
              error={passwordValidation ? true : false}
              helperText={passwordValidation ? "Password is Required" : ""}
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              style={{ backgroundColor: "white", borderRadius: "5px" }}
              id="password"
              value={password}
              onChange={handleInputTextChange}
              autoComplete="current-password"
            />
            <div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                style={{ width: "40%", marginTop: "15px" }}
              >
                Sign In
              </Button>
            </div>

            {loginSpinner ? (
              <CircularProgress style={{ color: "white" }} />
            ) : null}

            {loginError ? <Alert severity="error">{loginError}</Alert> : null}
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
